/*
  Slideshow video slides.

  The theme's slideshow plays and pauses only the first video player of a slide, and every
  slide's video starts as soon as the page loads, because all the slides sit on top of
  each other. This file corrects both:
  1. A slide with a desktop video and a mobile video: each play and pause goes to the
     player that is on screen, never to the hidden one.
  2. A slide that is not showing waits at the start of its video, and plays from the
     beginning the first time the slide appears. After that it resumes where it stopped,
     also when the slideshow loops round from the last slide to the first.
  Video players outside a slideshow are not touched.
*/
(function () {
  if (window.slideVideoPlayersReady) return;
  window.slideVideoPlayersReady = true;

  customElements.whenDefined('deferred-media').then(function (DeferredMedia) {
    var proto = DeferredMedia.prototype;
    var play = proto.playMedia;
    var pause = proto.pauseMedia;
    var load = proto.loadContent;
    if (typeof play !== 'function' || typeof pause !== 'function') return;
    if (typeof load !== 'function') return;

    function slideOf(player) {
      return player.closest('slideshow-component .swiper-slide');
    }

    function playersOf(slide) {
      return Array.prototype.slice.call(slide.querySelectorAll('deferred-media'));
    }

    function isDisplayed(player) {
      return player.getClientRects().length > 0;
    }

    // The slide the slideshow is showing. Before it has started, that is the first slide
    function isShowing(slide) {
      var slideshow = slide.closest('slideshow-component');
      var swiper = slideshow.swiperInstance;
      if (swiper && !swiper.destroyed && swiper.slides) {
        return swiper.slides[swiper.activeIndex] === slide;
      }
      var index = parseInt(slideshow.getAttribute('selected-index'), 10) || 0;
      return slideshow.querySelectorAll('.swiper-slide')[index] === slide;
    }

    // When a slideshow loops round, Swiper moves the slides and the theme resets the
    // video of a moved slide to its start. So remember where each video was paused,
    // and put it back
    function remember(player) {
      var video = player.querySelector(':scope > video');
      if (video && video.currentTime > 0) player.slideVideoResumeAt = video.currentTime;
    }

    function resume(player) {
      var at = player.slideVideoResumeAt;
      var video = player.querySelector(':scope > video');
      if (!at || !video) return;
      player.slideVideoResumeAt = 0;
      var seek = function () { if (video.currentTime < at) video.currentTime = at; };
      if (video.readyState >= 1) seek();
      else video.addEventListener('loadedmetadata', seek, { once: true });
    }

    proto.loadContent = function () {
      var slide = slideOf(this);
      if (slide && !isShowing(slide)) {
        // Load the video but do not start it: it waits until its slide is showing
        var template = this.querySelector('template');
        var video = template && template.content.querySelector('video');
        if (video) video.removeAttribute('autoplay');
      }
      return load.apply(this, arguments);
    };

    proto.playMedia = function () {
      var slide = slideOf(this);
      if (!slide) return play.apply(this, arguments);
      if (!isShowing(slide)) return Promise.resolve();
      if (isDisplayed(this)) {
        var result = play.apply(this, arguments);
        resume(this);
        return result;
      }

      // A hidden player was asked to play: play the players on screen instead
      return Promise.all(playersOf(slide).filter(isDisplayed).map(function (player) {
        var started = play.call(player);
        resume(player);
        return started;
      }));
    };

    proto.pauseMedia = function () {
      var result = pause.apply(this, arguments);
      remember(this);
      var slide = slideOf(this);

      // The slideshow only pauses the first player of a slide, when it leaves that slide:
      // pause the other players of the slide too
      if (slide && !isShowing(slide) && playersOf(slide)[0] === this) {
        playersOf(slide).forEach(function (player) {
          if (player === this) return;
          pause.call(player);
          remember(player);
        }, this);
      }
      return result;
    };
  });
})();